import { useEffect } from 'react';
import { useNavigate } from '../../utilities/PgmUtilities';
import { useLastLocationUrl } from '../side-nav/SidebarLocationHistory';

export default function LastPageRedirector() {
    const lastUrl = useLastLocationUrl();
    const navigate = useNavigate();

    useEffect(() => {
        if (!lastUrl) return;

        navigate(lastUrl, { replace: true });
    }, [lastUrl, navigate]);

    return null;
}
